import React from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import Button from "../../Button";
import { useNavigate } from "react-router-dom";

const _prefix = "chat-tendering__contract-signed";

const ContractSigned = ({ tenderingId }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/tenderings/${tenderingId}/documents/quotations`);
  };

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <div className={`${_prefix}__desc`}>
          <span className={`${_prefix}__desc__text`}>
            The contract has been successfully signed. You may now view
            documents, download all relevant files, including the final
            quotations, schedules, and contract.
          </span>
        </div>
        <Button label={"View Documents"} size="small" onClick={handleClick} />
      </div>
    </MessageContainer>
  );
};

ContractSigned.propTypes = {};

export default ContractSigned;
